// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"P0-z","sponsoredTooltipWrapper":"Q0-z","sponsoredTooltip":"R0-z","newCard":"S0-z"};